import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyDLvR7ruujaNqJxa2mkmXNY9TdVw2bgwjs",
authDomain: "tp-dynamic-qr.firebaseapp.com",
projectId: "tp-dynamic-qr",
storageBucket: "tp-dynamic-qr.firebasestorage.app",
messagingSenderId: "857964460075",
appId: "1:857964460075:web:260252c9b061aa3bbcd26e"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)

  // Configurar la persistencia de la sesión
  firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .catch((error) => {
      console.error("Error setting auth persistence:", error)
    })
}

export const auth = firebase.auth()
export const firestore = firebase.firestore()

export default firebase

